import axios from "axios";
import {IProduct, ISeedProductClone, ISeedProductSubmit} from 'src/infrastructure/interfaces';

const ProductService = {

    getAllProducts() {
        return new Promise((resolve, reject) => {
            axios
                .get('/completeProducts')
                .then((response) => {
                    resolve(response.data);
                })
                .catch(error => reject(error));
        });
    },

    getProductByID(id: number) {
        return new Promise((resolve, reject) => {
            axios
                .get('/products', {params: { id }, responseType: 'blob' })
                .then((response) => {
                    resolve(response.data);
                })
                .catch(error => reject(error));
        });
    },
    
    deleteProduct(id: number, type: string) {

        return new Promise((resolve, reject) => {
            axios
            .delete(`/products?id=` + id + '&type=' + type)
            .then((res) => {
                resolve();
            })
            .catch(error => reject(error));
        });
    },
    
    toggleProductPublish(id: number, type: string, published: boolean) {

        return new Promise((resolve, reject) => {
            axios
            .put(`/products?id=` + id + '&type=' + type + '&published=' + published)
            .then(() => {
                resolve();
            })
            .catch(error => reject(error));
        });
    },

    updateProduct(originalName: string, product: IProduct) {

        const isNewProduct = (product.id <= 0);
        if (isNewProduct) {
            return new Promise((resolve, reject) => {
                axios
                .post(`/completeProducts`, {params: { product }, responseType: 'json' })
                .then((res) => {
                    resolve(res.data);
                })
                .catch(error => reject(error));
            });
        }

        return new Promise((resolve, reject) => {
            axios
            .put(`/completeProducts`, {params: { originalName, product }, responseType: 'json' })
            .then((res) => {
                resolve(res.data);
            })
            .catch(error => reject(error));
        });
    },

    updateSeedProduct(seed: ISeedProductSubmit) {
        //no id, so it's a new seed
        if (!seed.id) {
            return new Promise((resolve, reject) => {
                axios
                .post(`/seed`, {...seed})
                .then((res) => {
                    resolve(res.data);
                })
                .catch(error => reject(error));
            });
        }

        return new Promise((resolve, reject) => {
            axios
            .put(`/seed/${seed.id}`, {...seed})
            .then((res) => {
                resolve(res.data);
            })
            .catch(error => reject(error));
        });
    },
    cloneSeedProduct(seed: ISeedProductClone) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/seedClone`, {...seed})
                .then((res) => {
                    resolve(res.data);
                })
                .catch(error => reject(error));
        });
    },
}

export default ProductService;



// WEBPACK FOOTER //
// ./src/services/ProductService.ts